module.exports = __webpack_public_path__ + "static/media/carousel-icon.3112ca34.svg";